export enum DeriskerEvent {
  INFOBOX_PRESSED = 'deriskerInfoboxPressed',
  INFOBOX_IMPRESSION = 'deriskerInfoboxImpression',
}
